import { breakpoints } from '@toggle/design-system';
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${breakpoints.lg} {
    flex-direction: row;
  }

  @media screen and (min-width: 1920px) {
    flex-direction: column;
    max-width: 632px;
    margin: 0 auto;
  }
`;

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--background-default);
`;

export const AssetInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
  padding: 32px 16px 0;
  margin-bottom: 40px;

  @media ${breakpoints.sm} {
    margin-bottom: 32px;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
  }
  @media ${breakpoints.md} {
    padding: 24px 24px 0;
  }

  @media screen and (min-width: 1920px) {
    padding: 24px 0 0;
  }
`;

export const TableWrapper = styled.div`
  @media ${breakpoints.md} {
    padding: 0 24px;
  }

  @media screen and (min-width: 1920px) {
    padding: 0;
  }
`;

export const Widget = styled.div`
  width: 100%;
  background-color: var(--background-default);
  border-left: 1px solid var(--border-soft);
  padding: 40px 16px;

  @media ${breakpoints.lg} {
    background-color: var(--background-soft);
    border-left: 1px solid var(--border-soft);
    padding: 40px 24px;
  }

  @media screen and (min-width: 1920px) {
    background-color: var(--background-default);
    padding: 40px 0;
    border: none;
  }
`;
